/**
 * Settings — localStorage helpers for app configuration.
 * Keys: serverUrl, apiKey, geminiApiKey, assetTagPrefix
 */

const KEYS = {
  serverUrl: 'snipe_server_url',
  apiKey: 'snipe_api_key',
  geminiApiKey: 'snipe_gemini_api_key',
  assetTagPrefix: 'snipe_asset_tag_prefix',
};

// Hardcoded Snipe-IT custom field column names
export const MAC_COLUMN_WLAN = '_snipeit_wlan_mac_address_6';
export const MAC_COLUMN_LAN = '_snipeit_mac_address_1';
export const MAC_COLUMN_IP = '_snipeit_local_ip_address_7';

export function getSetting(name) {
  return localStorage.getItem(KEYS[name]) || '';
}

export function setSetting(name, value) {
  localStorage.setItem(KEYS[name], value.trim());
}

export function getAllSettings() {
  return {
    serverUrl: getSetting('serverUrl'),
    apiKey: getSetting('apiKey'),
    geminiApiKey: getSetting('geminiApiKey'),
    assetTagPrefix: getSetting('assetTagPrefix'),
  };
}

export function isConfigured() {
  return !!(getSetting('serverUrl') && getSetting('apiKey'));
}
